import script from "./orderitem.vue?vue&type=script&setup=true&lang=js"
export * from "./orderitem.vue?vue&type=script&setup=true&lang=js"

import "./orderitem.vue?vue&type=style&index=0&id=e1fc1734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1fc1734"]])

export default __exports__